import type { ReactNode } from 'react';

export const symbol_rice_bowl: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M350-80q-12.75 0-21.37-8.63Q320-97.25 320-110v-40q-105-42-172.5-130T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 112-67.5 200T640-150v40q0 12.75-8.62 21.37Q622.75-80 610-80H350Zm40-399h180v-329q-22.33-6-44.67-9-22.33-3-45.08-3t-45.5 3Q412-814 390-808v329Zm-250 0h190v-306q-88 43-139 125.5T140-479Zm490 0h190q0-98-51-180.5T630-785v306ZM380-140h200v-51q79-34 143.5-90T811-419H149q23 82 87.5 138T380-191.23V-140Zm0 0h200-200Z"
		/>
	</svg>
);
